import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import eventBus from '../utils/eventBus';
import { ReactComponent as CloseIcon } from '../images/icons/white-close.svg';
import Templates from '../containers/Cosyflows';

const ContentOverlay = () => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const toggleHandler = () => {
            console.log('[CONTENT OVERLAY DEBUG] Toggle event received:', {
                currentOverlayState: showOverlay,
                currentRoute: location.pathname,
                action: showOverlay ? 'closing' : 'opening',
                timestamp: new Date().toISOString()
            });

            if (showOverlay) {
                handleClose();
            } else {
                setShowOverlay(true);
                setIsClosing(false);
            }
        };
        eventBus.on('toggle_content_overlay', toggleHandler);
        return () => eventBus.off('toggle_content_overlay', toggleHandler);
    }, [showOverlay, location.pathname]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setShowOverlay(false);
            setIsClosing(false);
            // Show the trigger button again
            const triggerBtn = document.getElementById('templates-trigger-button');
            if (triggerBtn) triggerBtn.style.display = 'block';
        }, 400); // Match animation duration
    };

    useEffect(() => {
        // Hide the trigger button when overlay is shown
        if (showOverlay) {
            const triggerBtn = document.getElementById('templates-trigger-button');
            if (triggerBtn) triggerBtn.style.display = 'none';
        }
    }, [showOverlay]);

    // Don't render overlay if user is on the full /templates route
    const isOnTemplatesRoute = location.pathname === '/templates' || location.pathname.startsWith('/templates/');

    console.log('[CONTENT OVERLAY DEBUG] Render check:', {
        showOverlay,
        isOnTemplatesRoute,
        currentRoute: location.pathname,
        shouldRender: showOverlay && !isOnTemplatesRoute
    });

    if (!showOverlay || isOnTemplatesRoute) return null;

    return (
        <div className={`absolute inset-0 z-[50] ${isClosing ? 'slide-out' : 'slide-in'}`}>
            <div className="relative bg-dark-blue/85 shadow-2xl w-full h-full overflow-y-auto">
                {/* Templates button on the left edge - sticky, doesn't scroll but slides with overlay */}
                <button
                    className="sticky top-1/2 -translate-y-1/2 -left-12 float-left py-8 px-3 rounded-l-lg shadow-2xl transition-colors duration-300"
                    style={{
                        zIndex: 9999,
                        backgroundColor: '#FFB02E',
                        color: '#000000',
                        border: '2px solid #FF9500',
                        marginLeft: '-3rem'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFC04D'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#FFB02E'}
                    onClick={handleClose}
                >
                    <span className="writing-mode-vertical text-sm font-bold whitespace-nowrap tracking-wider">TEMPLATES</span>
                </button>

                {/* Close button */}
                <button
                    className="absolute top-3 right-3 w-[46px] px-1 border border-cyan/50 rounded-lg hover:bg-cyan/10 transition z-50"
                    onClick={handleClose}
                >
                    <CloseIcon className="w-full" />
                </button>

                {/* Templates Component */}
                <div className="w-full h-full">
                    <Templates />
                </div>
            </div>
        </div>
    );
};

export default ContentOverlay;
